module.exports = __webpack_public_path__ + "static/img/ro.625aca9e.svg";